import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  selectNotificationPlanDetails,
  selectTerritoryNotificationBehavior,
} from '@/features/domain/territory'
import { Alert, Button } from '@mui/material'

import { form } from '../../formState'

import { useIsForeignUser } from '../../hooks/useIsForeignUser'
import { useTexts } from './hooks/useTexts'

export function VoiceAlert() {
  const status = form.useFormField('status')

  const territoryNotificationBehavior = useSelector(selectTerritoryNotificationBehavior)
  const isForeignUser = useIsForeignUser()
  const planDetails = useSelector(selectNotificationPlanDetails)
  const texts = useTexts()

  const advancedManagementDisabled = territoryNotificationBehavior !== 'EMAIL_AND_PHONE'
  const gotCommunicationPlan = planDetails.settings.hasSubscription

  const { showLearnMore, severity, description } = useMemo(() => {
    const isOff = status.field.value === 'OFF'
    const isAdvanced = status.field.value === 'ADVANCED'

    const showLearnMore = isAdvanced && (advancedManagementDisabled || isForeignUser)
    const severity = isOff || (isAdvanced && !advancedManagementDisabled) ? 'info' : 'warning'

    // Exceptions for Advanced users
    if (isAdvanced) {
      // If for the current country is not possible to receive calls
      if (isForeignUser) return { showLearnMore, severity, description: texts.foreign } as const

      if (advancedManagementDisabled) {
        const description = gotCommunicationPlan
          ? // If got a Communication Plan
            texts.advancedDisabledOnTerritory
          : // If got NO Communication Plan
            texts.advancedDisabled

        return { showLearnMore, severity, description } as const
      }
    }

    return {
      showLearnMore,
      severity,
      description: texts[status.field.value.toLocaleLowerCase()],
    } as const
  }, [texts, advancedManagementDisabled, gotCommunicationPlan, isForeignUser, status.field.value])

  return (
    <Alert severity={severity}>
      {description}
      {showLearnMore && (
        <>
          <br />
          <Button
            rel="noopener noreferrer"
            href="https://workwave.my.site.com/routemanager/s/article/Enhanced-Voice-Communication"
            target="_blank"
            sx={{ px: 0 }}
          >
            {texts.learnMore}
          </Button>
        </>
      )}
    </Alert>
  )
}
